// Same-tab browser navigation. Replaced only by the isolated mock fixture bundle.
export function navigateToApple(url) {
  window.location.assign(url);
}
